import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ChevronDown, ChevronUp } from "lucide-react";
import {AutoTranslate} from "@/lib/autoTranslate.tsx";

const languages = [
  { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
  // { code: 'pt', name: 'Portuguese', nativeName: 'Português' }, // Commented out due to translation issues
  { code: 'ru', name: 'Russian', nativeName: 'Русский' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'sw', name: 'Swahili', nativeName: 'Kiswahili' }
];

export function LanguageSelector({ bare = false }: { bare?: boolean }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[2];
  const getLanguage = () => i18n.language || window.localStorage.i18nextLng

  const changeLanguage = (code: string) => {
    console.log(code);
    console.log(getLanguage());
    i18n.changeLanguage(code);
    localStorage.setItem("language", code);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant={bare ? "ghost" : "outline"}
          className={bare ? "h-8 w-auto justify-start px-1 hover:bg-transparent" : "w-20 justify-between"}
        >
          {currentLanguage.code.toUpperCase()}
          <ChevronDown className="h-4 w-4 ml-2" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-0" align="end">
        <div className="flex items-center justify-between p-2 border-b">
          <span className="text-sm font-medium">{AutoTranslate(`Select Language`)}</span>
        </div>
        <ScrollArea className="h-80">
          <div className="p-2">
            {languages.map((lang) => (
              <Button
                key={lang.code}
                variant={i18n.language === lang.code ? "secondary" : "ghost"}
                className="w-full justify-start mb-1"
                onClick={() => changeLanguage(lang.code)}
              >
                <div className="flex flex-col items-start">
                  <span className="font-medium">{lang.name}</span>
                  <span className="text-xs text-muted-foreground">{lang.nativeName}</span>
                </div>
              </Button>
            ))}
          </div>
        </ScrollArea>
      </PopoverContent>
    </Popover>
  );
}
